"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createFramesPrintable;
const either_1 = require("../../types/either");
const createPrintable_1 = __importDefault(require("./createPrintable"));
const designs_1 = require("../designs");
function createFramesPrintable(userId, projectId, creationDate, template, designId, printableId) {
  const getDesignResult = (0, designs_1.findMatchingOrDefaultDesign)({
    newTemplateDesigns: template.designs,
    designId
  });
  if (getDesignResult.isLeft()) {
    return (0, either_1.left)(getDesignResult.value);
  }
  const layersResult = (0, designs_1.getLayersForDesign)({
    template,
    design1: getDesignResult.value
  });
  if (layersResult.isLeft()) {
    return (0, either_1.left)(layersResult.value);
  }
  return (0, createPrintable_1.default)(userId, projectId, getDesignResult.value.id, layersResult.value, template, printableId, creationDate);
}